export const getLabelByValue = (value: any, options: any[]) => {
  const option = options?.find((option) => option.value === value);
  return option ? option.label : "";
};
